import { render, staticRenderFns } from "./langSelectList.vue?vue&type=template&id=2d07c7fe&scoped=true"
import script from "./langSelectList.vue?vue&type=script&lang=js"
export * from "./langSelectList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d07c7fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d07c7fe')) {
      api.createRecord('2d07c7fe', component.options)
    } else {
      api.reload('2d07c7fe', component.options)
    }
    module.hot.accept("./langSelectList.vue?vue&type=template&id=2d07c7fe&scoped=true", function () {
      api.rerender('2d07c7fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/btn/lang/langSelectList.vue"
export default component.exports